var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("viewer", {
    ref: "toastuiEditorViewer",
    attrs: { initialValue: _vm.data, height: "500px" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }